import { render, staticRenderFns } from "./RecordImport.vue?vue&type=template&id=559cb468&scoped=true&"
import script from "./RecordImport.vue?vue&type=script&lang=js&"
export * from "./RecordImport.vue?vue&type=script&lang=js&"
import style0 from "./RecordImport.vue?vue&type=style&index=0&id=559cb468&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559cb468",
  null
  
)

export default component.exports